import { SwitchCase } from '@teamsparta/react';
import { Flex } from '@teamsparta/stack-flex';

import type { GNBDropdownMenu, GNBLinkMenu } from '../../constants';
import { DropdownMenu, LinkMenu } from './components';
import { useDropdownMenus } from './hook';

export function DropdownMenus({
  gnbMenus,
}: {
  gnbMenus: (GNBDropdownMenu | GNBLinkMenu)[];
}) {
  const { currentDropdownMenu, openDropdown, closeDropdown } =
    useDropdownMenus();

  return (
    <Flex gap={8} align='center'>
      {gnbMenus.map((menu) => (
        <SwitchCase
          key={menu.name}
          value={menu.type}
          cases={{
            dropdown: (
              <DropdownMenu
                {...(menu as GNBDropdownMenu)}
                key={menu.name}
                opened={currentDropdownMenu === menu.name}
                open={() => openDropdown(menu.name)}
                close={closeDropdown}
              />
            ),
            link: <LinkMenu {...(menu as GNBLinkMenu)} />,
          }}
        />
      ))}
    </Flex>
  );
}
